module.exports = __webpack_public_path__ + "img/forte6.fa500c24.jpeg";